import FormField from './field.js';
import DateHelper from '../../utils/date-helper';

export default class CarLeadTime extends FormField {
    constructor(parent, el) {
        super(parent, el);
        this.estimatedDeliveryWrapper = this.el.querySelector('.estimated-delivery-wrapper');
        this.estimatedMonthWrapper = this.estimatedDeliveryWrapper.querySelector('.estimated-delivery-month');        
        this.init();
    }

    init() {
        this.getOrder();
        this.setEstimatedDate();
    }

    async setEstimatedDate() {
        const carLeadTimesOrder = this.order?.temp?.leadTime;

        if (carLeadTimesOrder) {
            const estimatedDate = await window.HONDA.MyAccount2.client.getCarLeadTime(carLeadTimesOrder);
            const estimatedHandover = estimatedDate?.expectedHOD;
            const isDateAfter5Years = DateHelper.isDateAfterDaysFromToday({ date: estimatedHandover, days: 5 * 365 });
            if (estimatedHandover && !isDateAfter5Years) {
                const estimatedDeliveryMonth = DateHelper.getEstimatedMonth({ estimatedDate: estimatedHandover, locale: this.dateLocale, shouldRoundUpMonth: true });
                this.estimatedMonthWrapper.textContent = estimatedDeliveryMonth;
                this.estimatedDeliveryWrapper.classList.remove('loading');
                this.estimatedDeliveryWrapper.classList.add('loaded');
            } else {
                this.hideElements([this.estimatedDeliveryWrapper]);
            }
        } else {
            this.hideElements([this.estimatedDeliveryWrapper]);
        }
    }

    hideElements(elementList) {
        elementList.forEach((element) => {
            element.classList.add('hide');
        });
    }

    parse(json) {
        try {
            return json ? JSON.parse(json) : null;
        } catch (err) {
            return null;
        }
    }

    getOrder() {
        const json = sessionStorage.getItem('ma2-checkout');
        if (json) {
            this.order = this.parse(json);
        }
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_car_lead_time');
    }
}
